// The report contract is documented in docs/mockups/report-stock-by-variant.html.
export function reportPayload(body) {
  if (body?.status === false)
    throw new Error("Stock report API returned status=false");
  return body?.status !== undefined ? body.data : body;
}

export function reportSummary(body) {
  const payload = reportPayload(body);
  const values = Array.isArray(payload)
    ? Object.fromEntries(payload.map((card) => [card.title, card.value]))
    : payload;
  const keys = [
    "total_skus",
    "total_qty",
    "total_value",
    "low_count",
    "out_count",
  ];
  const backendKeys = {
    total_skus: "total_rows",
    total_qty: "total_stock",
    total_value: "total_stock_value",
    low_count: "low_stock_count",
    out_count: "out_of_stock_count",
  };
  const result = {};
  keys.forEach((key) => {
    const value = values?.[key] ?? values?.[backendKeys[key]];
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      !Number.isFinite(Number(value))
    ) {
      throw new Error(`get_summary_stock_report: missing or invalid ${key}`);
    }
    result[key] = Number(value);
  });
  return result;
}

export function reportTable(body) {
  const payload = reportPayload(body);
  if (
    !Array.isArray(payload?.data) ||
    payload.total == null ||
    !Number.isInteger(Number(payload.total)) ||
    Number(payload.total) < 0 ||
    !Number.isInteger(Number(payload.per_page)) ||
    Number(payload.per_page) <= 0
  )
    throw new Error("stock_report: expected { data: [], total, per_page }");
  payload.data.forEach((row, index) => {
    for (const key of ["stock", "min_stock", "stock_value"]) {
      if (
        row[key] == null ||
        row[key] === "" ||
        !Number.isFinite(Number(row[key]))
      ) {
        throw new Error(`stock_report row ${index}: missing or invalid ${key}`);
      }
    }
    if (!["in_stock", "low_stock", "out_of_stock"].includes(row.stock_status)) {
      throw new Error(`stock_report row ${index}: invalid stock_status`);
    }
    if (![true, false, 0, 1, "0", "1"].includes(row.has_variant)) {
      throw new Error(`stock_report row ${index}: invalid has_variant`);
    }
    if (
      [true, 1, "1"].includes(row.has_variant) &&
      (row.product_id == null || row.variant_name == null)
    ) {
      throw new Error(
        `stock_report row ${index}: variant requires product_id and variant_name`
      );
    }
  });
  return payload;
}

export function groupStockRows(rows) {
  const groups = new Map();
  rows.forEach((row, index) => {
    const variant =
      row.has_variant === true ||
      row.has_variant === 1 ||
      row.has_variant === "1";
    // Non-variant rows remain independent; ingredient and product IDs may collide.
    const key = variant ? `product:${row.product_id}` : `row:${index}`;
    if (!groups.has(key))
      groups.set(key, {
        key,
        product: row,
        variant,
        rows: [],
        stock: 0,
        value: 0,
      });
    const group = groups.get(key);
    group.rows.push({ ...row, rowNumber: index });
    group.stock += Number(row.stock);
    group.value += Number(row.stock_value);
  });
  return [...groups.values()];
}
